<main class="grow" role="content">
  <div class="kt-container-fixed py-5 lg:py-7.5">
    <header class="catalog-toolbar">
      <div class="catalog-toolbar-title">
        <h1 class="text-xl font-semibold text-mono">Catalogs</h1>
        <span class="text-sm text-secondary-foreground">{{ totalCount }} catalogs in {{ catalogGroups.length }} groups</span>
      </div>

      <div class="catalog-search" role="search">
        <i class="ki-filled ki-magnifier" aria-hidden="true"></i>
        <input
          #searchInput
          class="kt-input"
          type="search"
          placeholder="Search catalogs..."
          aria-label="Search catalogs"
          aria-keyshortcuts="/"
          autocomplete="off"
          [value]="searchTerm()"
          (input)="onSearch($event)"
          (keydown.enter)="openFirstMatch()"
          (keydown.escape)="clearSearch()"
        />
        @if (searchTerm()) {
          <button type="button" class="catalog-search-clear" (click)="clearSearch()" aria-label="Clear search" title="Clear search (Esc)">
            <i class="ki-filled ki-cross" aria-hidden="true"></i>
          </button>
        } @else {
          <kbd class="catalog-kbd" aria-hidden="true">/</kbd>
        }
      </div>
    </header>

    @if (!searchTerm() && recentItems().length > 0) {
      <nav class="catalog-recent" aria-label="Recently used catalogs">
        <span class="catalog-recent-label">
          <i class="ki-filled ki-time" aria-hidden="true"></i>
          Recent
        </span>
        @for (item of recentItems(); track item.route) {
          <a class="catalog-chip" [routerLink]="item.route" (click)="rememberRecent(item)">
            <i [class]="'ki-filled ki-' + item.icon" aria-hidden="true"></i>
            {{ item.title }}
          </a>
        }
      </nav>
    }

    @if (searchTerm()) {
      <p class="catalog-result-hint" aria-live="polite">
        @if (matchCount() > 0) {
          {{ matchCount() }} {{ matchCount() === 1 ? 'match' : 'matches' }} &middot; press <kbd class="catalog-kbd">Enter</kbd> to open the first one
        }
      </p>
    }

    @if (filteredGroups().length === 0) {
      <div class="kt-card flex flex-col items-center justify-center gap-2 p-10 text-center">
        <i class="ki-filled ki-file-deleted text-3xl text-muted-foreground" aria-hidden="true"></i>
        <span class="text-sm text-secondary-foreground">No catalogs match "{{ searchTerm() }}".</span>
      </div>
    }

    <div class="catalog-board">
      @for (group of filteredGroups(); track group.title) {
        <section class="kt-card catalog-group" [attr.aria-labelledby]="'catalog-group-' + $index">
          <h2 class="catalog-group-heading" [id]="'catalog-group-' + $index">
            <span class="catalog-group-icon" aria-hidden="true">
              <i [class]="'ki-filled ki-' + group.icon"></i>
            </span>
            <span class="catalog-group-title">{{ group.title }}</span>
            <span class="catalog-group-count">{{ group.items.length }}</span>
          </h2>

          <ul class="catalog-list">
            @for (item of group.items; track item.title) {
              <li>
                @if (item.route) {
                  <a class="catalog-link" [routerLink]="item.route" (click)="rememberRecent(item)">
                    <i [class]="'ki-filled ki-' + item.icon + ' catalog-link-icon'" aria-hidden="true"></i>
                    <span class="catalog-link-label">
                      @for (part of highlight(item.title); track $index) {
                        @if (part.match) {
                          <mark>{{ part.text }}</mark>
                        } @else {
                          {{ part.text }}
                        }
                      }
                    </span>
                    <i class="ki-filled ki-right catalog-link-chevron" aria-hidden="true"></i>
                  </a>
                } @else {
                  <span class="catalog-link catalog-link-disabled" aria-disabled="true">
                    <i [class]="'ki-filled ki-' + item.icon + ' catalog-link-icon'" aria-hidden="true"></i>
                    <span class="catalog-link-label">{{ item.title }}</span>
                  </span>
                }
              </li>
            }
          </ul>
        </section>
      }
    </div>
  </div>
</main>
